import                 './config'
import {apiBaseUrl}    from './config'
import {getBaseHeader} from './utils'
import SfpBaseService  from './sfp-base-service'
import LocalAuthority  from '../../model/local-authority'
import Rest            from '../../model/rest'

const LOCAL_AUTHORITIES_FRAGMENT = 'localauthorities'
const EXPENSE_FRAGMENT           = `expense`
const RECEIPTS_FRAGMENT          = `receipts`
const RESTS_FRAGMENT             = 'rests'

export default class RestsService extends SfpBaseService {

    /**
	 * @param   {LocalAuthority} localAuthority
	 * @param   {Rest}           rest
	 * @returns {Promise<Rest>}
	 */
	static createRest(localAuthority, rest) {
		const data = {
			amount : rest.amount,
			receipt: rest.receipt,
			year   : rest.year
		}

		const body    = JSON.stringify({rest: data})
		const headers = { ...getBaseHeader(), 'Content-Type': 'application/json' }
		const method  = 'POST'
		const url     = `${apiBaseUrl}/${LOCAL_AUTHORITIES_FRAGMENT}/${localAuthority.slug}/${RESTS_FRAGMENT}`

		return fetch(url, { body, headers, method }).then(response => {
            if (!response.ok) return response.json().then(error => { throw error })

            return Rest.createFromJson(response.json())
        })
    }

    /**
	 * @param {LocalAuthority} localAuthority
	 * @param {Rest}           rest
	 * @returns {Promise}
	 */
	static deleteRest(localAuthority, rest) {
		const headers = { ...getBaseHeader() }
		const method  = 'DELETE'
		const url     = `${RestsService._getBaseUrl(localAuthority, rest.receipt)}/${rest.year}`

		return fetch(url, { headers, method }).then(response => {
            if(!response.ok) return response.json().then(error => {throw error})

            switch(response.status){
                case 204: return true
                default:
            }
        })
    }

    /**
	 * @param   {LocalAuthority}       localAuthority
	 * @param   {Rest}                 rest
	 * @returns {Promise<Rest>}
	 */
	static updateRest(localAuthority, rest) {
		const data = { amount: rest.amount }

		const body    = JSON.stringify({ rest: data })
		const headers = { ...getBaseHeader(), 'Content-Type': 'application/json' }
		const method  = 'PUT'
		const url     = `${RestsService._getBaseUrl(localAuthority, rest.receipt)}/${rest.year}`

		return fetch(url, { body, headers, method }).then(response => {
            if(!response.ok) return response.json().then(error => {throw error})

			return response.json()
			.then(json => Rest.createFromJson(json))
			.catch(error => { throw new Error(error) })
        })
	}

	/**
	 * @param {LocalAuthority} localAuthority
	 * @param {boolean}        receipts
	 */
	static _getBaseUrl(localAuthority, receipts) {
		return `${apiBaseUrl}/${LOCAL_AUTHORITIES_FRAGMENT}/${localAuthority.slug}/${RESTS_FRAGMENT}/${receipts ? RECEIPTS_FRAGMENT : EXPENSE_FRAGMENT}`
	}
}


// WEBPACK FOOTER //
// ./src/service/sfp/rests-service.js